//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { pageMixin } from '@/mixins/pageMixin';
import CustomPagination from '@comp/page/custom-pagination';
import { getAction } from '@/api/manage';
export default {
  name: 'LogSiteList',
  mixins: [JeecgListMixin, GetSiteIdMixin, pageMixin],
  components: {
    CustomPagination: CustomPagination
  },
  data: function data() {
    return {
      autoLoadInit: false,
      pagePath: '/sys/log/site',
      pageTitle: '离线日志',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      isorter: {
        column: 'offline_time',
        order: 'desc'
      },
      // 表头
      columns: [// {
      //     title: '序号',
      //     dataIndex: '',
      //     key: 'rowIndex',
      //     width: 60,
      //     align: "center",
      //     customRender: function (t, r, index) {
      //         return parseInt(index) + 1;
      //     }
      // },
      {
        dataIndex: 'siteMn',
        colName: 'site_mn',
        title: '站点mn',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'clientIp',
        colName: 'client_ip',
        title: '客户端IP',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'serverIp',
        colName: 'server_ip',
        title: '服务端IP',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'offlineTime',
        colName: 'offline_time',
        title: '离线时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'onlineTime',
        colName: 'online_time',
        title: '恢复时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'offlineTimes',
        colName: 'offline_times',
        title: '离线时长(分钟)',
        align: 'center',
        sorter: true
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
      this.getPages(1, 100);
    }
  },
  computed: {},
  methods: {
    onDateOfflineTime: function onDateOfflineTime(value, dateArray) {
      this.queryParam.offlineTimeStart = dateArray[0];
      this.queryParam.offlineTimeEnd = dateArray[1];
    },
    onDateOnlineTime: function onDateOnlineTime(value, dateArray) {
      this.queryParam.onlineTimeStart = dateArray[0];
      this.queryParam.onlineTimeEnd = dateArray[1];
    }
  }
};